import { useState } from 'react';
import { InvoiceService } from '../../../services/invoice/invoiceService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage invoice clients fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de clientes.
----------------------------------------------------------------------------------------*/

const useInvoiceClients = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchInvoiceClients = async (f?: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new InvoiceService()).getInvoiceClients(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: {
                    id: string;
                    companyName: string;
                    cifNif: string;
                    registeredOfficeProvince?: string;
                    registeredOfficePostalCode?: string;
                }) => ({
                    value: data.id,
                    label: `${data.companyName} (${data.cifNif})`,
                    registeredOfficeProvince: data.registeredOfficeProvince ?? '',
                    registeredOfficePostalCode: data.registeredOfficePostalCode ?? '',
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching invoice clients:', error);
        }
    };

    const getInvoiceClientsList = () => {
        return data;
    };

    return { fetchInvoiceClients, getInvoiceClientsList };
}

export default useInvoiceClients;